(function (root, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.Progress = factory();
    }
}(this, function () {
    'use strict';
    var $w = window,
        $d = document,
        $article = document.querySelector('.single-post'),
        $circ = document.querySelector('.animated-circle'),
        $prog = document.querySelector('.progress-indicator'),
        init,
        wh,
        h,
        sHeight;

    function trigger(eventName) {
        var event = $d.createEvent('HTMLEvents');
        event.initEvent(eventName, true, false);

        $w.dispatchEvent(event);
    }

    function updateProgress(perc) {
        var circle_offset = 126 * perc;

        $circ.style.strokeDashoffset = 126 - circle_offset;

        if ((Math.round(perc * 100) >= 100)) {
            $prog.classList.add('read');
            $article.classList.add('article-read');
        } else {
            $prog.classList.remove('read');
            $article.classList.remove('article-read');
        }
    }

    function setSizes() {
        wh = $w.innerHeight;
        h = $article.offsetHeight;

        sHeight = h - wh;
    }

    function handler() {
        setSizes();
        trigger('scroll');
    }

    init = function () {
        var events = ['DOMContentLoaded', 'load', 'resize'], top, perc;

        setSizes();

        $w.addEventListener('scroll', function () {
            top = this.pageYOffset || $d.documentElement.scrollTop;
            perc = Math.max(0, Math.min(1, top / sHeight));

            updateProgress(perc);
        }, false);

        events.map(function (event) {
            $w.addEventListener(event, handler, false);
        });
    };

    return {
        init: init
    };
}));



// WEBPACK FOOTER //
// ./front/bankomania/js/vendors/progress.min.js